import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvService } from './env.service';
import { CallBackTransformService } from './call-back-transform.service';

@Injectable({
  providedIn: 'root',
})
export class PeopleListService {
  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private callBackTransformService: CallBackTransformService
  ) {}

  /**
   * peopleList
   * @param Object none
   * @return Object Resultset
   */
  peopleList(): Observable<any> {
    const url = this.envService.mockUrl + 'peoplelist';
    return this.http.get<any>(url);
  }

  /**
   * peopleList
   * @param Object none
   * @return Object Resultset
   */
  addPeople(peopleInfo): Observable<any> {
    const url = this.envService.apiUrl + 'person';
    return this.http.post<any>(url, peopleInfo).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * get user infor with ID
   * @param Object none
   * @return Object Resultset
   */
  getPeopleInfoById(id): Observable<any> {
    const url = this.envService.apiUrl + 'person/' + id;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * update k=list
   * @param Object peopleInfo
   * @return Object Resultset
   */
  updatePeople(peopleInfo): Observable<any> {
    const url = this.envService.apiUrl + 'person';
    return this.http.put<any>(url, peopleInfo).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * Api ti retreve people List
   */
  getPeopleListOld(userId, pageNo, pageSize, helperIndex?: any) {
    const url =
      this.envService.apiUrl +
      'persons/list/' +
      pageNo +
      '/' +
      pageSize +
      (!helperIndex || helperIndex === '' ? '' : `/${helperIndex}`);
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  getPeopleList(searchData: any,isDashboardView?) {
    let headers = new HttpHeaders();
    if(isDashboardView){
       headers = new HttpHeaders().set('ignoreProgressBar', "");
    }
    const options = { headers: headers };
    const url = this.envService.apiUrl + 'persons/list';
    return this.http.post<any>(url, searchData,options).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  getPeopleViewList(searchData: any) {
    let headers = new HttpHeaders();
    const options = { headers: headers };
    const url = this.envService.apiUrl + 'dashboard-persons-list';
    return this.http.post<any>(url, searchData,options).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /** present notification note
   *
   * @param Object addpresentnoteInfo
   * @return Object Resultset
   */

  AddPresentNotificationNote(addpresentnoteInfo): Observable<any> {
    const url = this.envService.apiUrl + 'add-notification-note';
    return this.http.put<any>(url, addpresentnoteInfo).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
  /** past notification note
   *
   * @param Object addpastnoteInfo
   * @return Object Resultset
   */

  AddPastNotificationNote(addpastnoteInfo): Observable<any> {
    const url = this.envService.apiUrl + 'add-notification-note';
    return this.http.put<any>(url, addpastnoteInfo).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * update k=list
   * @param Object personIndex
   * @return Object Resultset
   */
  removePeople(personIndex): Observable<any> {
    const url = this.envService.apiUrl + 'person/' + personIndex;
    return this.http.delete<any>(url).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * get Person Sharing Details
   * @param peopleIndex : people index
   */
  getPersonSharingDetails(peopleIndex): Observable<any> {
    const url =
      this.envService.apiUrl + 'person-sharing-details/' + peopleIndex;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

    /**
   * get Person collaboration history
   * @param peopleIndex : people index
   */
     getPersonHistory(peopleIndex, type): Observable<any> {
      const url =
        this.envService.apiUrl + 'audit-person-profile/' + peopleIndex + '/' + type;
      return this.http.get<any>(url).pipe(
        map((output) => {
          return this.callBackTransformService.transformOutput(output);
        }),
        catchError((err) => {
          return throwError(this.callBackTransformService.transformOutput(err));
        })
      );
    }

    updateContactInfo(peopleInfo): Observable<any> {
      const url = this.envService.apiUrl + 'shared-person';
      return this.http.put<any>(url, peopleInfo).pipe(
        map((output) => {
          return this.callBackTransformService.transformOutput(output);
        }),
        catchError((err) => {
          return throwError(this.callBackTransformService.transformOutput(err));
        })
      );
    }

    /**
     * Get person by people index (GUID)
     * @param peopleIndex : GUID (e.g., 378f3bdc-1682-4613-998d-d0d020d1d873)
     * @return Object Resultset
     */
    getPersonByPeopleIndex(peopleIndex: string): Observable<any> {
      const url = this.envService.apiUrl + 'person/' + peopleIndex;
      return this.http.get<any>(url).pipe(
        map((output) => {
          return this.callBackTransformService.transformOutput(output);
        }),
        catchError((err) => {
          return throwError(this.callBackTransformService.transformOutput(err));
        })
      );
    }

    /**
     * Get people natural supports by person ID
     * @param personId : numeric person ID (e.g., 154)
     * @return Object Resultset
     */
    getPeopleNaturalSupports(personId: number): Observable<any> {
      const url = this.envService.apiUrl + 'people-natural-supports/' + personId;
      return this.http.get<any>(url).pipe(
        map((output) => {
          return this.callBackTransformService.transformOutput(output);
        }),
        catchError((err) => {
          return throwError(this.callBackTransformService.transformOutput(err));
        })
      );
    }

    /**
     * Get people helpers by person ID and agency ID
     * @param personId : numeric person ID
     * @param agencyId : numeric agency ID
     * @return Object Resultset
     */
    getPeopleHelpers(personId: number, agencyId: number): Observable<any> {
      const url = this.envService.apiUrl + 'people-helpers/' + personId + '?agencyId=' + agencyId;
      return this.http.get<any>(url).pipe(
        map((output) => {
          return this.callBackTransformService.transformOutput(output);
        }),
        catchError((err) => {
          return throwError(this.callBackTransformService.transformOutput(err));
        })
      );
    }

    /**
     * Get people collaborations by person ID
     * @param personId : numeric person ID (e.g., 154)
     * @return Object Resultset
     */
    getPeopleCollaborations(personId: number): Observable<any> {
      const url = this.envService.apiUrl + 'people-collaborations/' + personId;
      return this.http.get<any>(url).pipe(
        map((output) => {
          return this.callBackTransformService.transformOutput(output);
        }),
        catchError((err) => {
          return throwError(this.callBackTransformService.transformOutput(err));
        })
      );
    }
}
